import React from "react";

export default function Vision() {
  const sections = [
    {
      title: "VISION",
      content: (
        <div className="">
          <p className="text-gray-100 text-lg leading-relaxed">
          To be a globally admired fragrance house that goes beyond creating scents — we aspire to inspire and enrich lives by crafting timeless aromas that evoke cherished memories, awaken deep emotions, and embody elegance across generations. Our vision is to transform the art of perfumery into a universal language of beauty and sophistication, where every fragrance we create becomes a lasting symbol of joy, connection, and cultural pride. Through innovation, craftsmanship, and respect for nature, we aim to set new global standards in fragrance excellence, making Bangladesh a name synonymous with artistry, authenticity, and timeless elegance in the world of perfumery.
          </p>
        </div>
      ),
    },
    {
      title: "MISSION",
      content: (
        <ul className="text-gray-100 text-lg leading-relaxed list-disc pl-5 space-y-3">
          <li>
            To craft perfumes, deodorants, and body care products that blend
            innovation, quality, and artistry.
          </li>
          <li>
            To combine the science of manufacturing with the art of perfumery,
            delivering excellence in every bottle.
          </li>
          <li>
            To establish Bangladesh as a hub for world-class fragrance
            production, serving both local and international markets.
          </li>
          <li>
            To create sustainable and ethical products that respect people,
            culture, and nature.
          </li>
        </ul>
      ),
    },
    {
      title: "CORE VALUES",
      content: (
        <div className="text-gray-100 text-lg leading-relaxed space-y-4">
          <div>
            <strong className="text-white">Passion for Fragrance – </strong>
            Every product we make tells a story, capturing emotions through
            scent.
          </div>
          <div>
            <strong className="text-white">Excellence & Quality – </strong>
            Commitment to world-class standards in every process, from raw
            materials to finished goods.
          </div>
          <div>
            <strong className="text-white">Innovation – </strong>
            Constantly creating new blends, packaging, and solutions that
            resonate with modern lifestyles.
          </div>
          <div>
            <strong className="text-white">Integrity – </strong>
            Building trust through transparency, fairness, and ethical
            practices.
          </div>
          <div>
            <strong className="text-white">Sustainability – </strong>
            Respecting nature, promoting halal and eco-conscious options, and
            reducing our environmental footprint.
          </div>
          <div>
            <strong className="text-white">Collaboration – </strong>
            Working hand-in-hand with partners, clients, and communities to
            share the beauty of fragrance worldwide.
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-[#ffffff] py-16 px-6 md:px-32 lg:px-40">
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-10">
        {sections.map((section, index) => (
          <div
            key={index}
            className="bg-[#373938] shadow-lg rounded-2xl p-8 hover:shadow-xl transition"
          >
            <div className="flex items-center mb-6">
              <span className="text-[#E9E3D8] text-2xl mr-3">🔥</span>
              <h2 className="text-2xl font-bold text-white tracking-wide">
                {section.title}
              </h2>
            </div>
            {section.content}
          </div>
        ))}
      </div>
    </div>
  );
}
